import { useTranslate } from 'react-polyglot';

import { BasicParagraph, Button, withPosition } from '@genially/design-system';
import { CloseIcon } from '@genially/icons';

import { CloseButton, StyledWarningIcon, Wrapper } from './ZeroParticipantsToast.styled';

interface ZeroParticipantsToastProps {
  className?: string;
  onInvite?: () => void;
  onClose?: () => void;
}

export const ZeroParticipantsToast = ({
  className,
  onInvite,
  onClose,
}: ZeroParticipantsToastProps) => {
  const t = useTranslate();

  const handleOnInvite = () => {
    onClose?.();

    onInvite?.();
  };

  const handleClose = () => {
    onClose?.();
  };

  return (
    <Wrapper className={className}>
      <StyledWarningIcon />
      <BasicParagraph> {t('__new.play.noParticipants.creator.tootip')}</BasicParagraph>
      <Button
        size={Button.Size.SMALL}
        variant={Button.Variant.STROKE}
        onClick={handleOnInvite}
      >
        {t('__new.play.noParticipants.creator.tootip.button')}
      </Button>
      <CloseButton onClick={handleClose} aria-label="Close">
        <CloseIcon />
      </CloseButton>
    </Wrapper>
  );
};

const ZeroParticipantsToastWithPosition = withPosition(ZeroParticipantsToast);

export default Object.assign(ZeroParticipantsToastWithPosition, {
  Placement: withPosition.Placement,
});
